import { del, get, patch, post, put } from '@eika-infrastruktur/request';

import { REST_CLICK2PAY_BASE_URL, REST_ELIGIBLE_CARDS } from '@/react-query/common';

import { Click2PayCustomer, Click2PayCustomerProfile, Click2PayProcess, EligibleCardInfo } from '@generated-types';

export const getClick2PayProfile = async () => get<Click2PayCustomerProfile>(`${REST_CLICK2PAY_BASE_URL}`);

export const createClick2PayProfile = async (customer: Click2PayCustomer, ecid: string) =>
    post<Click2PayProcess>(`${REST_CLICK2PAY_BASE_URL}/${ecid}`, customer);

export const updateClick2PayProfileEmail = async (email: string) =>
    patch<Click2PayProcess>(`${REST_CLICK2PAY_BASE_URL}`, email);

export const addClick2PayCard = async (eikaCardId: string) =>
    put<Click2PayProcess>(`${REST_CLICK2PAY_BASE_URL}/card/${eikaCardId}`, null);

export const removeClick2PayCard = async (eikaCardId: string) =>
    del<Click2PayProcess>(`${REST_CLICK2PAY_BASE_URL}/card/${eikaCardId}`);

export const getClick2PayEligibleCards = async () => get<EligibleCardInfo[]>(`${REST_ELIGIBLE_CARDS}`);
